import { IEventEnrollment } from '../../../../../store/admin/eventEnrollments/store';

export const filters = [
  { label: 'REGISTERED', callback: (item: IEventEnrollment) => item.status === 'active' },
  {
    callback: (item: IEventEnrollment) => item.status === 'waiting' || item.status === 'invited',
    label: 'WAITLIST'
  },
  {
    callback: () => true,
    label: 'ALL'
  }
];
